import {
    ISearch,
    ISearchProfile,
    ISearchProvider,
    HorizAlignment,
    SearchProviderFieldType,
    ISearchProviderField, ISearchRequestSubset
} from "../PA.UIM.Core/PA.UIM.Core.IF.Search"
import {PASearch} from "../PA.Core/PASearch";
import {SearchUtils} from "../PA.UIM.Core/SearchUtils";
import {PAEnvironment} from "../PA.Core/PAEnvironment";


var vUI_BaseLn_Fields: {[id:string]: ISearchProviderField } = {
    WB_BASELINE_ID:       {type: SearchProviderFieldType.number, renderOptions: { columnName: 'Baseline WB Id', columnResourceName: 'colId', alignment: HorizAlignment.Center}, domainOptions: {}},
    BASELINE_ID:       {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Baseline ID', columnResourceName: 'colBaselineId', alignment: HorizAlignment.Center}, domainOptions: { maxLength: 50}},
    BASELINE_NAME:    {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Name', columnResourceName: 'colName', alignment: HorizAlignment.Center}, domainOptions: { maxLength: 256}},
    CUSTOMER_NAME:       {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Customer Name', columnResourceName: 'colCustomerName', alignment: HorizAlignment.Center}, domainOptions: { maxLength: 50}},
    PERIOD_ID:       {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Period ID', columnResourceName: 'colPeriodId', alignment: HorizAlignment.Center}, domainOptions: { maxLength: 50}},
    SOURCE_ID:       {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Source ID', columnResourceName: 'colSourceId', alignment: HorizAlignment.Center}, domainOptions: { maxLength: 50}}
}

var BaseLnSearchProviderBasic: ISearchProvider = {

    keyFields: {id: 'WB_BASELINE_ID',
        id_ui: 'BASELINE_ID',
        name:  'BASELINE_NAME'},


    searchProviderFields: vUI_BaseLn_Fields,

    search(searchOptions: ISearchRequestSubset): Promise<any[]> {
        return new Promise<any[]>((resolve, error) => {

            let findRequest = SearchUtils.makeSearchRequest(searchOptions,
                'vUI_BaseLn_Search',
                this.searchProviderFields,
                [])

            PASearch.findByRequest(findRequest)
                .then((res: any[]) => {
                    resolve(res)
                })
                .catch((err)=> {
                    error(err)
                })
        })
    }

}


var BaseLnSearchProfileByName: ISearchProfile = {
    profileId: "default",
    profileName: "Search by Id, Name",
    renderOptions: { ui5ResourceId: "BaseLnSearchProfileByName" },

    profileFilter: [
        {profileFilterName: 'Id',     searchProviderFieldId: 'BASELINE_ID', renderOptions: { }},
        {profileFilterName: 'Name',     searchProviderFieldId: 'BASELINE_NAME', renderOptions: { }},
        {profileFilterName: 'Customer Name',     searchProviderFieldId: 'CUSTOMER_NAME', renderOptions: { }},
        {profileFilterName: 'Period ID',     searchProviderFieldId: 'PERIOD_ID', renderOptions: { }},
        {profileFilterName: 'Source ID',     searchProviderFieldId: 'SOURCE_ID', renderOptions: { }}
    ],  // ISearchFields
    profileDisplayFields: [
        'BASELINE_ID','BASELINE_NAME','CUSTOMER_NAME','PERIOD_ID','SOURCE_ID'
    ], //string[];   // Search Provider Field Name (Use to Generate Grid Columns)

    profileSearchProvider: BaseLnSearchProviderBasic,

    // Do sorting last.. not necessary for phase 1
    profileSortIdDefault: "",    //string;
    profileSorts: [] //ISearchSort[];
}


var BaseLnSearch: ISearch = {
    searchName: "Find Baseline",
    renderOptions: { ui5ResourceId: "BaseLnSearch"},
    searchProfileIdDefault: "default",
    searchProfiles: [BaseLnSearchProfileByName]
}
PAEnvironment.registerBusinessObjectSearch("BaseLnBO", "BaseLn", BaseLnSearch, "BaseLn Search")
export {BaseLnSearch}